import { render, staticRenderFns } from "./Notas.vue?vue&type=template&id=4d1e66bb"
import script from "./Notas.vue?vue&type=script&lang=js"
export * from "./Notas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports